import { type InputHTMLAttributes, forwardRef } from 'react';
import { cn } from '@/lib/cn';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  hint?: string;
  error?: string;
}

const Input = forwardRef<HTMLInputElement, Props>(
  ({ label, hint, error, className, ...rest }, ref) => (
    <label className="flex flex-col gap-1.5 text-sm">
      {label && <span className="text-xs text-muted">{label}</span>}
      <input
        ref={ref}
        {...rest}
        className={cn(
          'h-10 rounded-lg border bg-bg px-3 text-sm text-muted-strong placeholder:text-muted/50 focus:outline-none focus:border-accent-400 focus:ring-1 focus:ring-accent-400/40',
          error ? 'border-red-500/60' : 'border-slate-800',
          className
        )}
      />
      {hint && !error && <span className="text-xs text-muted">{hint}</span>}
      {error && <span className="text-xs text-red-400">{error}</span>}
    </label>
  )
);
Input.displayName = 'Input';
export default Input;
